import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
export var tabPaneArr = [{
  name: 'tab1',
  comp: function comp() {
    return import('./tab1-attendance');
  },
  data: {
    clo: [[
    // 考勤统计
    {
      label: '455',
      // 考勤项目
      prop: 'name',
      fixed: 'left',
      width: '504'
    }, {
      label: '456',
      // 类型
      prop: 'type_text',
      width: '240'
    }, {
      label: '457',
      // 计算规则
      prop: 'rule_key_text',
      type: 'input',
      width: '360'
    }], [
    // 加班项目
    {
      label: 'payroll_salary_41',
      // 加班项目
      prop: 'name',
      fixed: 'left',
      required: true,
      width: '504'
    }, {
      label: '456',
      // 类型
      prop: 'type_text',
      required: true,
      width: '240'
    }, {
      label: 'payroll_salary_42',
      // 时薪倍数（倍）
      prop: 'rule_key_text',
      type: 'input',
      required: true,
      width: '360'
    }], [
    // 考异异常
    {
      label: 'payroll_salary_43',
      // 考勤异常项目
      prop: 'name',
      fixed: 'left',
      width: '504'
    }, {
      label: '456',
      // 类型
      prop: 'type_text',
      width: '240'
    }, {
      label: '457',
      // 计算规则
      prop: 'rule_key_text',
      type: 'input',
      width: '360'
    }]],
    info: {
      selectTable: {},
      day_hour: {
        id: '',
        val: '',
        type: '',
        name: ''
      },
      extend: {
        cycle_hire_no_leave: {
          type: 1,
          after: '',
          before: ''
        },
        cycle_no_hire_leave: {
          type: 1,
          after: '',
          before: ''
        }
      }
    },
    cInfo: {
      selectTable: {},
      day_hour: {
        id: '',
        val: '',
        type: '',
        name: ''
      },
      extend: {
        cycle_hire_no_leave: {
          type: 1,
          after: '',
          before: ''
        },
        cycle_no_hire_leave: {
          type: 1,
          after: '',
          before: ''
        }
      }
    }
  },
  id: 7 // 考勤设置
}, {
  name: 'tab2',
  comp: function comp() {
    return import('./tab2-wages');
  },
  data: {
    // 月结和其他
    fixClo: [[
    // 固定薪资
    {
      label: 'payroll_wage_34',
      // 固定薪资名称
      prop: 'name',
      fixed: 'left',
      width: '504'
    }, {
      label: 'payroll_salary_37',
      // 计薪天数（天）
      prop: 'type_text',
      type: 'number',
      width: '240'
    }, {
      label: 'payroll_salary_38',
      // 不计算天数规则
      prop: 'rule_key_text',
      type: 'select',
      width: '400'
    }], [
    // 固定薪资导入项
    {
      label: 'payroll_salary_39',
      // 固定薪资导入项名称
      prop: 'name',
      fixed: 'left',
      width: '504'
    }, {
      label: '456',
      // 类型
      prop: 'type_text',
      width: '240'
    }
    // {
    //   label: 'action', // 操作
    //   prop: '',
    //   type: 'action',
    //   width: '120'
    // }
    ]],

    // 日结
    fixClo1: [[
    // 固定薪资
    {
      label: 'payroll_wage_34',
      // 固定薪资名称
      prop: 'name',
      fixed: 'left',
      width: '504'
    }, {
      label: 'payroll_salary_37',
      // 计薪天数（天）
      prop: 'type_text',
      type: 'number',
      width: '240'
    }, {
      label: 'payroll_salary_51',
      // 不计算天数规则
      prop: 'rule_key_text',
      type: 'select',
      width: '400'
    }], [
    // 固定薪资导入项
    {
      label: 'payroll_salary_39',
      // 固定薪资导入项名称
      prop: 'name',
      fixed: 'left',
      width: '504'
    }, {
      label: '456',
      // 类型
      prop: 'type_text',
      width: '240'
    }
    // {
    //   label: 'action', // 操作
    //   prop: '',
    //   type: 'action',
    //   width: '120'
    // }
    ]],

    notFixClo: [[
    // 非固定薪资（按天计算）
    {
      label: 'payroll_salary_40',
      // 非固定薪资名称
      prop: 'name',
      fixed: 'left',
      width: '360'
    }, {
      label: '456',
      // 类型
      prop: 'type_text',
      width: '192'
    }, {
      label: 'payroll_salary_44',
      // 是否计算税
      prop: 'is_tax_text',
      value: 'is_tax',
      type: 'switch',
      width: '192'
    }, {
      label: 'payroll_salary_45',
      // 是否计算社保
      prop: 'is_ss_text',
      value: 'is_ss',
      type: 'switch',
      width: '192'
    }, {
      label: '24916_936db327',
      // 是否计入福利基金
      prop: 'is_ewf_text',
      value: 'is_ewf',
      type: 'switch',
      width: '192'
    }, {
      label: 'payroll_salary_46',
      // 计算天数规则
      prop: 'not_days_text',
      type: 'select',
      width: '360'
    }], [
    // 非固定薪资导入项
    {
      label: 'payroll_salary_48',
      // 非固定薪资导入项名称
      prop: 'name',
      fixed: 'left',
      width: '504'
    }, {
      label: '456',
      // 类型
      prop: 'type_text',
      width: '192'
    }, {
      label: 'payroll_salary_44',
      // 是否计算税
      prop: 'is_tax_text',
      value: 'is_tax',
      type: 'switch',
      width: '192'
    }, {
      label: 'payroll_salary_45',
      // 是否计算社保
      prop: 'is_ss_text',
      value: 'is_ss',
      type: 'switch',
      width: '216'
    }, {
      label: '24916_936db327',
      // 是否计入福利基金
      prop: 'is_ewf_text',
      value: 'is_ewf',
      type: 'switch',
      width: '216'
    }
    // {
    //   label: 'action', // 操作
    //   prop: '',
    //   type: 'action',
    //   width: '120'
    // }
    ], [
    // 考勤设置
    {
      label: 'payroll_salary_47',
      // 考勤设置项目名称
      prop: 'name',
      fixed: 'left',
      width: '504'
    }, {
      label: '456',
      // 类型
      prop: 'type_text',
      width: '192'
    }, {
      label: 'payroll_salary_44',
      // 是否计算税
      prop: 'is_tax_text',
      value: 'is_tax',
      type: 'switch',
      width: '192'
    }, {
      label: 'payroll_salary_45',
      // 是否计算社保
      prop: 'is_ss_text',
      value: 'is_ss',
      type: 'switch',
      width: '216'
    }, {
      label: '24916_936db327',
      // 是否计入福利基金
      prop: 'is_ewf_text',
      value: 'is_ewf',
      type: 'switch',
      width: '216'
    }]],
    extend: {
      attendance_belong_to: {
        type: 1,
        after: '',
        before: ''
      },
      overtime_belong_to: {
        type: 1,
        after: '',
        before: ''
      },
      update_salary_day_last_later: {
        type: 1,
        after: '',
        before: ''
      }
    },
    info: {
      notFixTable: {},
      fixTable: {},
      extend: {}
    },
    cInfo: {
      notFixTable: {},
      fixTable: {},
      extend: {}
    }
  },
  id: 1 // 工资设置
}, {
  name: 'tab3',
  comp: function comp() {
    return import('./tab3-tax');
  },
  data: {
    info: {
      extend: {
        cycle_hire_tax_strategy: {
          type: 1
        },
        cycle_leave_tax_strategy: {
          type: 1
        }
      }
    },
    cInfo: {
      extend: {
        cycle_hire_tax_strategy: {
          type: 1
        },
        cycle_leave_tax_strategy: {
          type: 1
        }
      }
    }
  },
  id: 2 // 税设置
}, {
  name: 'tab4',
  comp: function comp() {
    return import('./tab4-security');
  },
  data: {
    info: {
      social_security: '',
      // 个人社保缴纳比例（%）
      social_security_base_max: '',
      // 社保基数最大值
      social_security_base_min: '',
      // 社保基数最小值
      social_security_company: '' // 企业缴纳社保比例（%）
    },

    cInfo: {
      social_security: '',
      // 个人社保缴纳比例（%）
      social_security_base_max: '',
      // 社保基数最大值
      social_security_base_min: '',
      // 社保基数最小值
      social_security_company: '' // 企业缴纳社保比例（%）
    }
  },

  id: 3 // 社保设置
}, {
  name: 'tab5',
  comp: function comp() {
    return import('./tab5-setting');
  },
  data: {
    info: {
      list: []
    },
    cInfo: {
      list: []
    }
  },
  id: 0 // 社保设置
}];